import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { CssBaseline } from '@material-ui/core';
import { Switch, Route, withRouter, Redirect } from 'react-router-dom';
import { themes, components } from '@peachjar/components';
import { css } from 'react-emotion';
import BrandBar from './components/BrandBar/BrandBar';
import PortalRouter from './router';
import { FatalErrorScreen, Error404Screen } from './errors';

import UserStateDispatcher from './UserStateDispatcher';

import config from '../config';

import './App.css';

const featureSwitchPortal = config.REACT_APP_FEATURE_PORTAL;

const { ModalRoot, ModalProvider } = components;

class App extends Component {
  componentWillMount() {
    this.props.appInitialize();
  }

  render() {
    const { hasFatalError } = this.props;
    const showApp = !hasFatalError && featureSwitchPortal;
    if (showApp) console.warn('[Feature switch] Portal: On');

    return (
      <Fragment>
        <div className="App">
          <ModalRoot />
          {/* Tech Debt: Replace this magic fixed px value with a variable representing what it's for */}
          <div style={{ paddingTop: '83px', margin: 0 }}>
            <BrandBar isShowingLogin={false} />
          </div>
          <div className={classNames.content}>
            {!showApp ? (
              <FatalErrorScreen />
            ) : (
              <UserStateDispatcher>
                <PortalRouter />
              </UserStateDispatcher>
            )}
          </div>
        </div>
      </Fragment>
    );
  }
}

App.propTypes = {
  children: PropTypes.array,
  sessionOpen: PropTypes.bool,
  routes: PropTypes.array,
  authenticated: PropTypes.bool,
  appInitialize: PropTypes.func,
};

const classNames = {
  content: css`
    flex: 1 1 auto;
    display: flex;
    flex-flow: column nowrap;
  `,
};

const mapStateToProps = state => ({
  user: state.user,
  isAuthenticated: state.user.isAuthenticated,
  hasFatalError: state.errors.hasFatalError,
});

const mapDispatchToProps = dispatch => ({
  appInitialize: () => dispatch({ type: 'APP_INITIALIZE' }),
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(App)
);



// WEBPACK FOOTER //
// ./src/_app/App.js